(() => {
  function isWeekend(d) {
    const day = d.getDay(); // 0 Sun, 6 Sat
    return day === 0 || day === 6;
  }

  function addBusinessDays(date, days) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) added++;
    }
    return d;
  }

  function nextBusinessDay(date) {
    const d = new Date(date);
    while (isWeekend(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  function startOfDay(d) {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
  }

  function formatDate(d, format = "long") {
  if (format === "short") {
    return new Intl.DateTimeFormat(undefined, {
      month: "short",
      day: "numeric",
    }).format(d);
  }

  // default (PDP)
  return new Intl.DateTimeFormat(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
  }).format(d);
}


  function computeShipDate(leadDays, cutoffHour) {
    const now = new Date();

    // Weekend -> next business day base
    let base = nextBusinessDay(now);

    // After cutoff on a business day -> start from next business day
    const sameDay = base.toDateString() === now.toDateString();
    if (sameDay && now.getHours() >= cutoffHour) {
      base = addBusinessDays(base, 1);
    }

    base = startOfDay(base);

    // leadDays is business days from base
    if (leadDays <= 0) return base;
    return addBusinessDays(base, leadDays);
  }

  function init() {
    const blocks = document.querySelectorAll(".lm-est-arrival");
    if (!blocks.length) return;

    blocks.forEach((el) => {
      const lead = parseInt(el.dataset.leadDays || "1", 10);
      const cutoff = parseInt(el.dataset.cutoffHour || "14", 10);

      const transitMin = parseInt(el.dataset.transitMin || "3", 10);
      const transitMax = parseInt(el.dataset.transitMax || "5", 10);

      // Compute ship date using your existing logic
      const shipDate = computeShipDate(lead, cutoff);

      // Arrival range = ship date + standard shipping (business days)
      const start = addBusinessDays(shipDate, transitMin);
      const end = addBusinessDays(shipDate, transitMax);

      const out = el.querySelector(".lm-est-arrival__date");
      const format = el.dataset.format || "long";
      if (out) {
        out.textContent = `${formatDate(start, format)} – ${formatDate(end, format)}`;
      }
    });

  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();










/* ORIGINAL BLOCK BELOW FOR ESTIMATED SHIP DATE REPLACE BY BLOCK ABOVE MODDED FOR ESTIMATED ARRIVAL DATE
(() => {
  function isWeekend(d) {
    const day = d.getDay(); // 0 Sun, 6 Sat
    return day === 0 || day === 6;
  }

  function addBusinessDays(date, days) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) added++;
    }
    return d;
  }

  function nextBusinessDay(date) {
    const d = new Date(date);
    while (isWeekend(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  function startOfDay(d) {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
  }

  function formatDate(d) {
    return new Intl.DateTimeFormat(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
    }).format(d);
  }

  function computeShipDate(leadDays, cutoffHour) {
    const now = new Date();

    // Weekend -> next business day base
    let base = nextBusinessDay(now);

    // After cutoff on a business day -> start from next business day
    const sameDay = base.toDateString() === now.toDateString();
    if (sameDay && now.getHours() >= cutoffHour) {
      base = addBusinessDays(base, 1);
    }

    base = startOfDay(base);

    // leadDays is business days from base
    if (leadDays <= 0) return base;
    return addBusinessDays(base, leadDays);
  }

  function init() {
    const blocks = document.querySelectorAll(".lm-est-ship");
    if (!blocks.length) return;

    blocks.forEach((el) => {
      const lead = parseInt(el.dataset.leadDays || "1", 10);
      const cutoff = parseInt(el.dataset.cutoffHour || "14", 10);

      const shipDate = computeShipDate(lead, cutoff);
      const out = el.querySelector(".lm-est-ship__date");
      if (out) out.textContent = formatDate(shipDate);
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
*/
